<template>
  <div id="app" v-if="!isLoading">
    <router-view :key="$route.path"/>
    <Footer />
  </div>
</template>

<script>
//import NavBar from "@/components/navBar/NavBar.vue"
import Footer from "@/components/footer/Footer.vue"
import EventBus from "@/EventBus"
export default {
  data: () => ({
    isLoading: true
  }),
  mounted() {
    EventBus.$on("i18n-load-start", () => (this.isLoading = true))
    EventBus.$on("i18n-load-complete", () => (this.isLoading = false))
  },
  components: { Footer }
}
</script>

<style lang="scss">
  body, #app, a, * { 
    font-family: "Roobert ENEL";
    font-weight: normal;
}

@font-face {
  font-family: "Roobert ENEL";
  font-style: normal;
  font-weight: 200;
  src: url("./assets/fonts/roobert/RoobertENEL-Light.eot?#iefix") format("embedded-opentype"), 
       url("./assets/fonts/roobert/RoobertENEL-Light.woff2") format("woff2"), 
       url("./assets/fonts/roobert/RoobertENEL-Light.woff") format("woff"), 
       url("./assets/fonts/roobert/RoobertENEL-Light.ttf") format("truetype"); }

@font-face {
  font-family: "Roobert ENEL";
  font-style: normal;
  font-weight: 400;
  src: url("./assets/fonts/roobert/RoobertENEL-Regular.eot?#iefix") format("embedded-opentype"), 
       url("./assets/fonts/roobert/RoobertENEL-Regular.woff2") format("woff2"), 
       url("./assets/fonts/roobert/RoobertENEL-Regular.woff") format("woff"), 
       url("./assets/fonts/roobert/RoobertENEL-Regular.ttf") format("truetype"); }

@font-face {
  font-family: "Roobert ENEL";
  font-style: normal;
  font-weight: 900;
  src: url("./assets/fonts/roobert/RoobertENEL-Bold.eot?#iefix") format("embedded-opentype"), 
       url("./assets/fonts/roobert/RoobertENEL-Bold.woff2") format("woff2"), 
       url("./assets/fonts/roobert/RoobertENEL-Bold.woff") format("woff"), 
       url("./assets/fonts/roobert/RoobertENEL-Bold.ttf") format("truetype"); }

/*!
 * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
@font-face {
  font-family: 'Font Awesome 5 Free';
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url("./assets/fonts/fontawesome/fa-solid-900.eot");
  src: url("./assets/fonts/fontawesome/fa-solid-900.eot?#iefix") format("embedded-opentype"), 
       url("./assets/fonts/fontawesome/fa-solid-900.woff2") format("woff2"), 
       url("./assets/fonts/fontawesome/fa-solid-900.woff") format("woff"), 
       url("./assets/fonts/fontawesome/fa-solid-900.ttf") format("truetype"), 
       url("./assets/fonts/fontawesome/fa-solid-900.svg#fontawesome") format("svg"); }

.fa,
.fas {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900; }

/*!
 * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
@font-face {
  font-family: 'Font Awesome 5 Brands';
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url("./assets/fonts/fontawesome/fa-brands-400.eot");
  src: url("./assets/fonts/fontawesome/fa-brands-400.eot?#iefix") format("embedded-opentype"), 
       url("./assets/fonts/fontawesome/fa-brands-400.woff2") format("woff2"), 
       url("./assets/fonts/fontawesome/fa-brands-400.woff") format("woff"), 
       url("./assets/fonts/fontawesome/fa-brands-400.ttf") format("truetype"), 
       url("./assets/fonts/fontawesome/fa-brands-400.svg#fontawesome") format("svg"); }

.fab {
  font-family: 'Font Awesome 5 Brands';
  font-weight: 400; }
  
</style>
